import { render } from "./WhatWeOffer.vue?vue&type=template&id=4098e0b6"
import script from "./WhatWeOffer.vue?vue&type=script&lang=js"
export * from "./WhatWeOffer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__